import styled, { keyframes } from 'styled-components';

// Animation for floating money icons
const float = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(5deg); }
`;

// Decorative elements
const MoneyIcon = styled.div`
  position: absolute;
  color: rgba(255, 255, 255, 0.25);
  font-size: ${(props) => props.size || '18px'};
  animation: ${float} 3s ease-in-out infinite;
  animation-delay: ${(props) => props.delay || '0s'};
  pointer-events: none;
  z-index: 1;

  &.icon-1 {
    top: 50%;
    right: 180px;
    transform: translateY(-50%);
    font-size: 16px;
  }

  &.icon-2 {
    top: 20%;
    right: 140px;
    font-size: 14px;
  }

  &.icon-3 {
    bottom: 25%;
    right: 160px;
    font-size: 15px;
  }

  &.icon-4 {
    top: 15px;
    right: 15px;
    font-size: 16px;
  }

  &.icon-5 {
    bottom: 15px;
    right: 20px;
    font-size: 14px;
  }

  @media (max-width: 1024px) {
    &.icon-1 {
      right: 160px;
    }
    &.icon-2 {
      right: 120px;
    }
    &.icon-3 {
      right: 140px;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export default MoneyIcon;
